jQuery_T4NT(document).ready(function($) {

    var allPagesLoaded = false; // Flag to track if all pages have been loaded

    $(window).scroll(function() {
        var paginationWrapper = $('.t4s-pagination-wrapper');
        var loadPreviewButton = $('.loadpreview');
        
        // Check if URL contains ?page=1
        if (window.location.href.indexOf('?page=1') !== -1) {
            return; // Stop further execution if ?page=1 is in the URL
        }

        if (!allPagesLoaded && paginationWrapper.length && loadPreviewButton.length) {
            if (isInViewport(paginationWrapper)) {
                loadPreviewButton.click();
            }
        }
    });

    // Function to check if an element is in the viewport
    function isInViewport(elem) {
        var bounding = elem[0].getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

//   for (let i = 0; i <= 9; i++) {
//   $(`.JAVA-${i}`).click(function() {
//     // Hide all elements with class starting with "PYTHON-"
//     for (let j = 0; j <= 9; j++) {
//       if (j !== i) {
//         $(`.PYTHON-${j}`).css("display", "none");
//       }
//     }
//     // Remove "is--opend" class from all elements with class starting with "JAVA-"
//     for (let k = 0; k <= 9; k++) {
//       if (k !== i) {
//         $(`.JAVA-${k}`).removeClass("is--opend");
//       }
//     }
//   });
// }


    // Function to indicate that all pages have been loaded
    function setAllPagesLoaded() {
        allPagesLoaded = true;
    }

    // Call setAllPagesLoaded() function when all pages are loaded
    // Replace the selector '#page' with the appropriate selector for your pagination elements
    $(document).on('allPagesLoadedEvent', setAllPagesLoaded);
  
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

// MENU

document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.querySelector('.toggleopen');   // Open button
    const toggleButtonClose = document.querySelector('.toggleclose'); // Close button
    const sidebarmenue = document.querySelector('.sidebarmenue');   // Sidebar
    const bodyscroll = document.querySelector('body.template-index'); 

    // OPEN
    toggleButton.addEventListener('click', function () {
        sidebarmenue.classList.add('active');
        toggleButton.classList.add('active');
        toggleButtonClose.classList.remove('active');
        bodyscroll.classList.add('stopscroll');
    });

    // CLOSE
    toggleButtonClose.addEventListener('click', function () {
        sidebarmenue.classList.remove('active');  // remove active class
        toggleButton.classList.remove('active');
        toggleButtonClose.classList.add('active');
        bodyscroll.classList.remove('stopscroll');
    });
});

// MEGA MENUE

document.addEventListener("DOMContentLoaded", function () {

  const items = document.querySelectorAll(".mm-parent-item");
  const panels = document.querySelectorAll(".mm-group-panel");

  if (items.length > 0) {

    // Default open 1st panel
    const first = items[0].dataset.group;
    const openPanel = document.getElementById(first);
    if (openPanel) {
      openPanel.style.display = "grid";
      items[0].classList.add("active-parent");
    }

    // Hover switch
    items.forEach(btn => {
      btn.addEventListener("mouseenter", function () {
        panels.forEach(p => p.style.display = "none");
        items.forEach(i => i.classList.remove("active-parent"));

        const id = this.dataset.group;
        const pn = document.getElementById(id);
        if (pn) pn.style.display = "grid";

        this.classList.add("active-parent");
      });
    });
  }

});
document.addEventListener("DOMContentLoaded", function () {

  const listItems = document.querySelectorAll(".live-search-list li");
  const searchBox = document.querySelector(".live-search-box");

  // Add data-search-term to each <li>
  listItems.forEach(li => {
    li.dataset.searchTerm = li.textContent.toLowerCase();
  });

  // Keyup event on search box
  searchBox.addEventListener("keyup", function () {

    const searchTerm = this.value.toLowerCase();

    listItems.forEach(li => {
      const liText = li.dataset.searchTerm;

      if (liText.includes(searchTerm) || searchTerm.length < 1) {
        li.style.display = "block";
      } else {
        li.style.display = "none";
      }
    });

  });

});

